import { LoadingOutlined, UploadOutlined } from "@ant-design/icons";
import styled from "styled-components";

export const StyledLoadingOutlined = styled(LoadingOutlined)`
    font-size: 12px;
`;

export const StyledUploadOutlinedBig = styled(UploadOutlined)`
    font-size: 24px;
    && {
        color: ${(props) => props.theme.primaryTypographyColor};
    }
`;
